import React from 'react'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Button from '@material-ui/core/Button';

class CustomDialog extends React.PureComponent {
  render() {

    const { id, qid, fullScreen, isopen, handleClose, variant, title, handleAccept, children, agreeColor, disagreeColor, agreeLabel, disagreeLabel } = this.props
    return (
      <Dialog
        fullScreen={fullScreen || false}
        open={isopen === true}
        onClose={handleClose}
      >
        <DialogTitle id={id}>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {children || 'Agree?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={e=> {
              e.preventDefault()
              handleClose()
            }} variant={variant || "text"} color={disagreeColor || "default"} autoFocus>
            {disagreeLabel || "CANCEL"}
          </Button>
          <Button  onClick={e=> {
              e.preventDefault()
              handleAccept(qid)
            }} variant={variant || "text"} color={agreeColor || "primary"}>
            {agreeLabel || "OK"}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withMobileDialog()(CustomDialog);



// WEBPACK FOOTER //
// ./src/js/components/inputs/CustomDialog.js